import React, {Component} from "react"
{/*ELEM REACT16 CHANGE */}
import Spinner from "components/Spinner/Spinner"
import {Button, FormInput, Form, Loader } from "semantic-ui-react"
import serialize from "form-serialize"
import Attachments from "components/Attachments/Attachments"
import shop from "shop/shop"
//import "../../theme/scantex/style/Form.scss"

export default class ContactFormPage extends Component {
	state = {
		loading: false,
		error  : false,
		page   : false,
		files  : []
	}

	constructor( props ) {
		super( props )
	}

	componentDidMount() {
		let slug = this.props.match.params.slug
		this.load( slug )
	}

	componentWillReceiveProps( props ) {
		let slug = props.match.params.slug

		console.log( `received slug`, slug )
		if ( this.state.slug === slug ) return
		this.load( slug )
	}

	load( slug ) {
		this.setState( {slug, loading: true} )
		shop.form( slug )
			.then( res => {
				console.log( `res`, res )
				return res
			} )
			.then( pages => pages[0] )
			.then( ( page ) => {
				console.log( `loaded page`, page )
				this.setState( {page, loading: false} )
			} )
			.catch( error => {
				this.setState( {error} )
			} )
	}

	onSubmit = ( e ) => {
		if ( this.state.loading ) return
		const form = serialize( e.target, {hash: true} )
		//onSubmit({form})
		console.info( `submitting form`, form )
		this.setState( {form, loading: true} )
		shop.service.request( this.state.slug, form )
			.then( response => {
				this.setState( {response, loading: false} )
				console.log( `Form Response`, response )
			} )
		e.preventDefault()
		return false
	}

	render() {
		let {page, form, response, loading} = this.state
		let {allowUploads} = page && page.acf
		return (
			<div className="container pt4">
				<div className="">
					<tr>
						<td sm="1/2">
							<Form className="Form--cms" onSubmit={this.onSubmit}>
								{page ? <div dangerouslySetInnerHTML={{__html: page.content.rendered}}></div> : <div>Lade Formular</div>}
								{allowUploads &&
								<div className="pt0 pb5">
									<Attachments accept=".jpg,.jpeg,.png"
												 onChange={( {files} ) => {
													 this.setState( {loading: true} )
													 console.log( `uploading files`, files )
													 if ( files ) {
														 shop.service.params( files )
															 .catch( error => {
																 console.error( "Error Uploading File:", error )
																 this.setState( {loading: false} )
															 } )
															 .then( res => res.text() )
															 .then( response => {
																 console.log( `adding file`, response )
																 this.setState( {loading: false, files: [response]} )
															 } )
													 }
												 }}>
										{this.state.files.length === 0 && <Button>Datei auswählen</Button>}
										{(this.state.files.length > 0) && <div className="">
											{this.state.files.map( file => <FormInput hidden key={file} value={file} name="attachment" /> )}
										</div>}
									</Attachments>
								</div>}

								<div className="FormField">
									<Button disabled={loading} submit type="primary">{loading ? <Spinner /> : null} Absenden</Button>
								</div>
							</Form>
						</td>
						<td sm="1/2">
							<div>
								<h2>Debug: Formularinhalt</h2>
								<pre>{JSON.stringify( form, null, 2 )}</pre>
								<h2>Debug: Server Antwort</h2>
								{response ? <div>
									<pre>URL: {response.url}</pre>
									<pre>Status: {response.status}</pre>
									<pre>Text: {response.statusText}</pre>
									<pre>{JSON.stringify( response, null, 2 )}</pre>
								</div> : null}
							</div>
						</td>
					</tr>
				</div>
			</div>
		)
	}
}




// WEBPACK FOOTER //
// ./src/pages/form/FormDebuggerPage.js